import { render, staticRenderFns } from "./AppWithAntd.vue?vue&type=template&id=1576b50e&scoped=true&"
import script from "./AppWithAntd.vue?vue&type=script&lang=js&"
export * from "./AppWithAntd.vue?vue&type=script&lang=js&"
import style0 from "./AppWithAntd.vue?vue&type=style&index=0&id=1576b50e&scoped=true&lang=css&"
import style1 from "./AppWithAntd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1576b50e",
  null
  
)

export default component.exports